/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Cra_SuccessInputs */

const en_ticket_action_cra_success = /** @type {(inputs: Ticket_Action_Cra_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logged: access refused.`)
};

const ja_ticket_action_cra_success = /** @type {(inputs: Ticket_Action_Cra_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録: アクセス拒否。`)
};

const fr_ticket_action_cra_success = /** @type {(inputs: Ticket_Action_Cra_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré : accès refusé.`)
};

const de_ticket_action_cra_success = /** @type {(inputs: Ticket_Action_Cra_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfasst: Zugang verweigert.`)
};

/**
* | output |
* | --- |
* | "Logged: access refused." |
*
* @param {Ticket_Action_Cra_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_cra_success = /** @type {((inputs?: Ticket_Action_Cra_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Cra_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_cra_success(inputs)
	if (locale === "ja") return ja_ticket_action_cra_success(inputs)
	if (locale === "fr") return fr_ticket_action_cra_success(inputs)
	return de_ticket_action_cra_success(inputs)
});